import { emitNavigationRequest } from './navigationEvents'

export const guardAccessDenied = (response) => {
  if (response?.data?.msg === 'Acesso negado') {
    emitNavigationRequest('/dashboard')
  }
  return response
}
